export enum AlertLevel {
  INFO, SUCCESS, ERROR, WARNING
}

export type Alert = {
  title: string;
  description: string;
  level: AlertLevel;
}
